import { createFeatureSelector, createSelector } from '@ngrx/store';

import { pushNotificationsFeatureKey, State } from '../reducers/push-notifications.reducer';

export const selectPushNotificationsFeature = createFeatureSelector<State>(pushNotificationsFeatureKey);

export const selectToken = createSelector(selectPushNotificationsFeature, (state: State) => state.token);
